var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: "green" },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v("データを読み込んでいます。しばらくお待ちください..."),
          ]),
        ],
        1
      )
    : _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "container my-4" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-12 col-md-10 col-lg-8" }, [
              _c("div", { staticClass: "card mb-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("img", {
                      staticClass: "img-fluid w-100",
                      attrs: { src: _vm.subscription.premiumServiceUrl },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-7" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h2", { staticClass: "h6 fw-bold mb-4" }, [
                        _vm._v("現在のプラン"),
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "h5 fw-bold" }, [
                        _vm._v(_vm._s(_vm.subscription.premiumServiceName)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary mb-3" }, [
                        _vm._v(
                          "契約更新日: " +
                            _vm._s(
                              _vm.dateFormat(
                                new Date(
                                  _vm.stripeUpcomingInvoice.nextPaymentAttempt
                                )
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary fw-bold" }, [
                        _vm._v(
                          "月額料金: ¥" +
                            _vm._s(
                              _vm.localNumber(
                                _vm.calcTaxIncluded(
                                  _vm.subscription &&
                                    _vm.subscription.premiumServicePrice
                                    ? _vm.subscription.premiumServicePrice
                                    : 0
                                )
                              )
                            ) +
                            "（税込み）"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary fw-bold" }, [
                        _vm._v(
                          "入会金: ¥" +
                            _vm._s(
                              _vm.localNumber(
                                _vm.subscription &&
                                  _vm.subscription.needMembershipFee
                                  ? _vm.subscription.membershipFee
                                  : 0
                              )
                            ) +
                            "（税込み）"
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-4 border-primary" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("img", {
                      staticClass: "img-fluid w-100",
                      attrs: { src: _vm.targetPremiumService.imageUrl },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-7" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("h2", { staticClass: "h6 fw-bold mb-4" }, [
                        _vm._v("変更後のプラン"),
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "h5 fw-bold" }, [
                        _vm._v(_vm._s(_vm.targetPremiumService.name)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary mb-3" }, [
                        _vm._v(
                          "次回更新日: " +
                            _vm._s(
                              _vm.dateFormat(
                                _vm.subscriptionCompared.targetPaymentAt
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary mb-4 fw-bold" }, [
                        _vm._v(
                          "月額料金: ¥" +
                            _vm._s(
                              _vm.localNumber(_vm.targetPremiumService.price)
                            ) +
                            "（税込み）"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-secondary fw-bold" }, [
                        _vm._v(
                          "入会金: ¥" +
                            _vm._s(
                              _vm.localNumber(
                                _vm.targetPremiumService.membershipFee
                              )
                            ) +
                            "（税込み）"
                        ),
                      ]),
                      _vm._v(" "),
                      false &&
                      _vm.subscriptionCompared.targetPaymentTrialPrice > 0
                        ? _c("div", { staticClass: "price-alert" }, [
                            _vm._v(
                              "\n                  差額 ¥" +
                                _vm._s(
                                  _vm.localNumber(
                                    _vm.subscriptionCompared
                                      .targetPaymentTrialPrice
                                  )
                                ) +
                                "を次回請求時に加算させていただきます\n                "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card bg-light border mb-4" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h2", { staticClass: "h6 fw-bold mb-3" }, [
                    _vm._v("プラン変更に関する注意事項"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "text-secondary small mb-0 ps-3" }, [
                    _c("li", { staticClass: "mb-2" }, [
                      _vm._v("プラン変更は即時反映されます"),
                    ]),
                    _vm._v(" "),
                    _vm.subscriptionCompared.targetPaymentTrialPrice > 0
                      ? _c("li", { staticClass: "mb-2" }, [
                          _vm._v("差額は次回請求時に加算されます"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", [_vm._v("契約更新日は変更されません")]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-between" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-light border px-4",
                      attrs: {
                        to:
                          "/classroom/subscription/" +
                          _vm.subscription.id +
                          "?tab=CHANGE_PLAN",
                      },
                    },
                    [_vm._v("キャンセル")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary px-4 text-white",
                      on: { click: _vm.submitChangePlan },
                    },
                    [_vm._v("次へ進む")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress rounded-0" }, [
      _c("div", {
        staticClass: "progress-bar bg-primary",
        staticStyle: { width: "33%" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container mt-4" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-12 col-md-10 col-lg-8" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c("div", { staticClass: "progress-step text-center" }, [
              _c(
                "div",
                { staticClass: "step-circle step-circle-active mx-auto" },
                [_vm._v("1")]
              ),
              _vm._v(" "),
              _c(
                "small",
                { staticClass: "d-block mt-2 progress-step-active" },
                [_vm._v("プランの確認")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-step text-center" }, [
              _c("div", { staticClass: "step-circle mx-auto" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("small", { staticClass: "d-block mt-2 text-secondary" }, [
                _vm._v("お支払い"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "progress-step text-center" }, [
              _c("div", { staticClass: "step-circle mx-auto" }, [_vm._v("3")]),
              _vm._v(" "),
              _c("small", { staticClass: "d-block mt-2 text-secondary" }, [
                _vm._v("完了"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center my-4" }, [
      _c("div", { staticClass: "plan-change-arrow mx-auto" }, [
        _vm._v("\n            ↓\n          "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }